import React from 'react';

const YouTubeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M12.04,18.82c-3.32,0-6.13-1.44-6.13-4.79c0-3.35,2.81-4.79,6.13-4.79s6.13,1.44,6.13,4.79 C18.17,17.38,15.36,18.82,12.04,18.82z M12.04,10.03c-2.4,0-4.07,1-4.07,3.99c0,3,1.67,4,4.07,4s4.07-1,4.07-4 C16.11,11.03,14.44,10.03,12.04,10.03z"></path>
    <path d="M21.58,8.23c-0.23-0.84-0.88-1.5-1.72-1.72C18.25,6.02,12,6.02,12,6.02s-6.25,0-7.86,0.49 c-0.84,0.23-1.5,0.88-1.72,1.72C2.02,9.84,2.02,14,2.02,14s0,4.16,0.4,5.77c0.23,0.84,0.88,1.5,1.72,1.72 C5.75,21.98,12,21.98,12,21.98s6.25,0,7.86-0.49c0.84-0.23,1.5-0.88,1.72-1.72C22,18.16,22,14,22,14S22,9.84,21.58,8.23z M13.8,14.39l-3.23,1.73V11.25l3.23,1.73V14.39z"></path>
  </svg>
);

export default YouTubeIcon;